module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.matchWholeNodeNamesOnly),
      expression: "matchWholeNodeNamesOnly"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.matchWholeNodeNamesOnly) ? _vm._i(_vm.matchWholeNodeNamesOnly, null) > -1 : (_vm.matchWholeNodeNamesOnly)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.matchWholeNodeNamesOnly,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.matchWholeNodeNamesOnly = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.matchWholeNodeNamesOnly = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.matchWholeNodeNamesOnly = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Match whole node names only")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onAutoTagModelClick
    }
  }, [_vm._v("Execute")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "disabled": _vm.isBusy
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-22bb353e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22bb353e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/auto-tag-model-dialog/auto-tag-model-dialog.vue.html
// module id = 1084
// module chunks = 0